import {
  Pencil,
  Star,
  X,
  Settings,
  MoreVertical,
  Plus,
  MoreHorizontal,
  ChevronRight,
  PhoneCall,
  Mail,
  MessageSquare,
} from "lucide-react";
import { useState } from "react";
import Avatar from "../../../../../component/ui/avatar";
// import Avatar from "../../../../../component/ui/avatar";

const notes = [
  {
    type: "Behavior",
    color: "bg-[#fff9e9]",
    border: "border-[#ddd7d7]",
    iconColor: "text-[#FF8F0D]",
    text: "Filler text is text that shares some characteristics of a real written text, but is random or otherwise generated. It may be used to display a sample of fonts",
    author: "Lale Temori",
  },
  {
    type: "Attitude",
    color: "bg-[#ecfff0]",
    border: "border-[#ddd7d7]",
    iconColor: "text-[#8BC442]",
    text: "Filler text is text that shares some characteristics of a real written text, but is random or otherwise generated. It may be used to display a sample of fonts",
    author: "Lale Temori",
  },
  {
    type: "Negative",
    color: "bg-[#fff2f5]",
    border: "border-[#ddd7d7]",
    iconColor: "text-[#FF0000]",
    text: "Filler text is text that shares some characteristics of a real written text, but is random or otherwise generated. It may be used to display a sample of fonts",
    author: "Lale Temori",
  },
];

const interviewers = [
  {
    name: "Aiden Blake Thompson",
    title: "Senior UI Design",
    department: "Design Team",
  },
  {
    name: "Liam Carter Johnson",
    title: "Senior HR Manager",
    department: "HR Deprtment",
  },
  {
    name: "Noah Alexander Smith",
    title: "Senior UI Design",
    department: "Design Team",
  },
];

function TabPlaceholder({ icon: Icon, title, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-slate-300 rounded-2xl bg-white">
      <div className="flex items-center justify-center size-14 rounded-full bg-slate-100 mb-4">
        <Icon className="size-6 text-slate-500" />
      </div>
      <h3 className="text-lg font-semibold text-slate-700">{title}</h3>
      <p className="text-sm text-slate-500 mt-1">{message}</p>
      <div className="mt-4 px-4 py-2 text-xs text-slate-400 border border-solid border-slate-200 rounded-full bg-slate-50">
        🚧 Under Development
      </div>
    </div>
  );
}

function NoteCard({ type, color, border, iconColor, text, author }) {
  return (
    <div
      className={`${color} ${border} border rounded p-[10px] flex flex-col gap-[15px]`}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-1.5">
          {/* <Star className={`w-6 h-6 ${iconColor}`} /> */}
          <span className="text-[#212121] text-[18px]">{type}</span>
        </div>
        {/* <X className="w-6 h-6 text-[#92929D]" /> */}
      </div>
      <p className="text-[#666666] text-[14px] leading-4">{text}</p>
      <p className="text-[#616161] text-[10px] leading-4 font-bold">
        Created By: {author}
      </p>
    </div>
  );
}

function InterviewerCard({ name, title, department }) {
  return (
    <div className="h-[64px] rounded border border-[#e1e4ea] p-[15px] flex items-center justify-between">
      <div className="flex items-center  justify-between gap-4">
        <div className="flex items-center gap-[5px]">
          <Avatar src={"boss.png"} title={name} />
          <p className="text-[#333333] text-[12px] w-[139px] font-medium truncate">
            {name}
          </p>
        </div>
        <div className="flex flex-col gap-[2px]">
          <p className="text-[#333333] text-[12px] truncate font-medium">
            {title}
          </p>
          <p className="text-[#999999] text-[10px] truncate">{department}</p>
        </div>
      </div>
    </div>
  );
}

export function RightSidebar({ isOpen, onToggle }) {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <div
      className={`
        transition-all duration-300 ease-in-out shrink-0 h-full
        ${isOpen ? "w-[500px]" : "w-0 p-0 overflow-hidden"}
      `}
    >
      <div className="p-2 flex flex-col gap-4 overflow-hidden overflow-y-auto h-full">
        {/* Tab Navigation */}
        <div className="rounded-[10px] bg-white border border-[#E1E4EA] py-[8px] px-[8px] flex-shrink-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-[10px]">
              {[
                { label: "Note" },
                { label: "Email" },
                { label: "SMS" },
                { label: "Calls" },
              ].map((item, idx) => {
                const active = idx === tabIndex; // first tab active

                return (
                  <button
                    key={idx}
                    className={`px-[25px] py-[7px] flex items-center gap-1 text-[14px] text-[#414651] font-medium rounded-[10px] transition-all border
                    ${
                      active
                        ? "bg-[#F6F6F6] border-[#DDD]"
                        : "bg-[#ffffff] border-[#e1e4ea]"
                    }    
                                              `}
                    onClick={() => {
                      setTabIndex(idx);
                    }}
                  >
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>

            {/* Right side filter icon */}
            <div className="text-[#B7B8BB] text-xl cursor-pointer transition-all hover:text-gray-600 flex gap-1 items-center">
              <button
                onClick={onToggle}
                className="p-1 rounded-md bg-blue-600 text-white 
             hover:bg-blue-700 hover:shadow-md 
             active:scale-95 
             transition-all duration-200 group"
              >
                <ChevronRight
                  size={18}
                  className="transition-transform duration-200 group-hover:translate-x-1"
                />
              </button>
            </div>
          </div>
        </div>

        {tabIndex == 0 ? (
          <>
            {/* Notes Panel */}
            <div className="bg-white h-full rounded-[10px] border border-[#e1e4ea] p-[10px] flex flex-col gap-[5px]">
              {/* Notes Content */}
              <div className="flex flex-col gap-[20px]">
                <div className="flex items-center gap-3">
                  <h2 className="text-[#0e121b] text-[20px] leading-[38px] flex-1">
                    Note
                  </h2>
                  <button className="flex items-center gap-[10px] px-[9px] py-[5px]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11 4.00023H6.8C5.11984 4.00023 4.27976 4.00023 3.63803 4.32721C3.07354 4.61483 2.6146 5.07378 2.32698 5.63826C2 6.28 2 7.12008 2 8.80023V17.2002C2 18.8803 2 19.7204 2.32698 20.3622C2.6146 20.9266 3.07354 21.3856 3.63803 21.6732C4.27976 22.0002 5.11984 22.0002 6.8 22.0002H15.2C16.8802 22.0002 17.7202 22.0002 18.362 21.6732C18.9265 21.3856 19.3854 20.9266 19.673 20.3622C20 19.7204 20 18.8803 20 17.2002V13.0002M7.99997 16.0002H9.67452C10.1637 16.0002 10.4083 16.0002 10.6385 15.9449C10.8425 15.8959 11.0376 15.8151 11.2166 15.7055C11.4184 15.5818 11.5914 15.4088 11.9373 15.0629L21.5 5.50023C22.3284 4.67181 22.3284 3.32866 21.5 2.50023C20.6716 1.67181 19.3284 1.6718 18.5 2.50023L8.93723 12.0629C8.59133 12.4088 8.41838 12.5818 8.29469 12.7836C8.18504 12.9626 8.10423 13.1576 8.05523 13.3617C7.99997 13.5919 7.99997 13.8365 7.99997 14.3257V16.0002Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span className="text-[#999999] text-[14px]">
                      Edit Info
                    </span>
                  </button>
                </div>

                <div className="flex flex-col gap-[10px]">
                  {notes.map((note, idx) => (
                    <NoteCard key={idx} {...note} />
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : tabIndex == 1 ? (
          <div className="bg-white h-full rounded-[10px] border border-[#e1e4ea] p-[10px] flex flex-col gap-[5px]">
            <TabPlaceholder
              icon={Mail}
              title="Emails"
              message="Email activity and history will be available soon."
            />
          </div>
        ) : tabIndex == 2 ? (
          <div className="bg-white h-full rounded-[10px] border border-[#e1e4ea] p-[10px] flex flex-col gap-[5px]">
            <TabPlaceholder
              icon={MessageSquare}
              title="SMS"
              message="SMS communication history is under development."
            />
          </div>
        ) : tabIndex == 3 ? (
          <div className="bg-white h-full rounded-[10px] border border-[#e1e4ea] p-[10px] flex flex-col gap-[5px]">
            <TabPlaceholder
              icon={PhoneCall}
              title="Calls"
              message="We are working on the call logs and recordings section."
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
